module.exports = __webpack_public_path__ + "static/img/pg one.18380bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/pg one.jpg
// module id = c8AM
// module chunks = 1